var getWrap = function (flexWrap) {
    if (flexWrap === true) {
        return "wrap";
    }
    if (flexWrap === false) {
        return "nowrap";
    }
    return flexWrap === "reverse" ? flexWrap : "";
};
export default (function (_a) {
    var flexWrap = _a.flexWrap;
    var value = getWrap(flexWrap);
    return value && "flex-wrap: " + value + ";";
});
